/**
 * Created by jane on 17-5-3.
 */

import _ from 'lodash';
import * as kecConst from './constants';

export default {
    [kecConst.createProduct](state, createProductSet) {
        state.createProductSet = createProductSet;
    },
    [kecConst.judgeGameUser](state, judgeGameUser) {
        state.judgeGameUser = judgeGameUser;
    },
    [kecConst.QuerySingleKVM](state, kecPriceSysSet) {
        state.KecSystem = kecPriceSysSet.data.productTypeList;
        state.RootSizeQuota = kecPriceSysSet.RootSizeQuota;
    },
    [kecConst.OSImageList](state, imageConfig) {
        state.osImages = imageConfig.images || {};
        state.pTypeConfig = imageConfig.p_type_config || [];
    },

    [kecConst.getAvoidPackage](state, avoidSet) {
        state.avoidSet = avoidSet;
    },

    [kecConst.createAviod](state, createAvoidSet) {
        state.createAvoidSet = createAvoidSet;
    },

    [kecConst.QueryDedicatedHostPackage](state, dedicatePriceSysSet) {
        state.dedicatePriceSysSet = dedicatePriceSysSet;
    },

    [kecConst.DedicateList](state, DedicateList) {
        state.DedicateListSet = DedicateList;
    },

    [kecConst.getAvoidList](state, avoidListSet) {
        state.avoidListSet = avoidListSet;
    },

    [kecConst.QueryEbsPackage](state, kecEbsSet) {
        state.kecEbsSet = kecEbsSet;
    },
    [kecConst.ImageList](state, imageSet) {
        state.imageSet = imageSet;
    },
    [kecConst.GetInstanceByIds](state, data) {
        console.log(data);
        state.instanceByIds = data;
    },
    [kecConst.QueryEipPackage](state, eipSet) {
        var lineSet = {};
        var lineNameSet = {};
        function lineNameMap(key) {
            var map = {
                '移动': 'YiDong',
                '电信': 'DianXin',
                '联通': 'LianTong',
                '优化BGP': 'zenlayer-guoneiyouhua'
            };
            return map[key] || 'BGP';
        }
        _.each(eipSet.LineSet, function(item) {
            lineSet[item.LineId] = lineNameMap(item.LineName);
            lineNameSet[item.LineId] = item.LineName;
        });
        state.eipSet = eipSet;
        state.eipLineSet = lineSet;
        state.eipLineNameSet = lineNameSet;
    },
    [kecConst.checkBwsConfig](state, checkBwsConfigSet) {
        state.checkBwsConfigSet = checkBwsConfigSet;
    },
    [kecConst.getProjList](state, data) {
        state.getProjList = data;
    },
    [kecConst.bandwidthList](state, bandwidthListSet) {
        state.bandwidthListSet = bandwidthListSet;
    },
    [kecConst.AllVpcInfo](state, allVpcSet) {
        state.allVpcSet = allVpcSet;
    },

    [kecConst.AdrList](state, adrListSet) {
        state.adrListSet = adrListSet;
    },
    [kecConst.AllocatedAdrList](state, NotAvailableIpAddress) {
        state.NotAvailableIpAddress = NotAvailableIpAddress.AvailableIpAddress;
    },
    [kecConst.DescribeSubnets](state, SubnetSet) {
        state.SubnetSet = SubnetSet.SubnetSet;
    },
    [kecConst.DescribeInstancePrivateIpQuota](state, data) {
        state.instancePrivateIpQuota = data;
    },
    [kecConst.AssignPrivateIpAddress](state, data) {
        state.assignPrivateIpAddressData = data;
    },
    [kecConst.UnAssignPrivateIpAddress](state, data) {
        state.UnAssignPrivateIpAddressData = data;
    },
    [kecConst.calcKvmPrice](state, kecPriceSet) {
        state.kecPriceSet = kecPriceSet;
    },
    [kecConst.calcEipPrice](state, eipPriceSet) {
        state.eipPriceSet = eipPriceSet;
    },
    [kecConst.calcAvoidPrice](state, avoidPriceSet) {
        state.avoidPriceSet = avoidPriceSet;
    },
    [kecConst.getTagKeysList](state, tagKeySet) {
        state.tagKeySet = tagKeySet;
    },
    [kecConst.describeTagValues](state, tagValueSet) {
        state.tagValueSet = tagValueSet;
    },
    // 试用订单权限
    [kecConst.checkTryOrder](state, res) {
        // 如果有productTypeList，说明有试用权限，否则没有试用权限
        state.checkTryOrder = !!res?.productTypeList?.length;
    },
    // 试用订单的billtype
    [kecConst.QueryTryBillType](state, res) {
        state.eipBill = res.eipBill;
        state.kecBill = res.kecBill;
        state.kecDiscount = res.kecDiscount;
        state.eipDiscount = res.eipDiscount;
    },
    [kecConst.validDia](state, res) {
        state.validDia = res;
    },
    //查询用户折扣信息
    [kecConst.queryDisCount](state, res) {
        state.disCountObj = res.disCountObj;
    },
    //获取ebs信息
    [kecConst.queryRenewEbsVolumes](state, res) {
        state.ebsVolumesData = res.data;
    },
    [kecConst.DescribeInstances](state, res) {
        // res.list[0].InstanceState.Name = 'stopping'
        state.list = res.list
        state.total = res.total
    },
    [kecConst.validDia](state, res) {
        state.validDia = res;
    },

    [kecConst.RegionInfos](state, res) {
        state.RegionInfos = res;
    },
    //选中的tag和属性项
    [kecConst.colsChecked](state, res) {
        state.listChecked = res.listChecked;
        state.tagsChecked = res.tagsChecked;
    },
    [kecConst.Getlines](state, data) {
        var lineSet = {};
        var lineNameSet = {};
        state.LineSet = data.LineSet || [];
        function lineNameMap(key) {
            var map = {
                '移动': 'YiDong',
                '电信': 'DianXin',
                '联通': 'LianTong',
                '优化BGP': 'zenlayer-guoneiyouhua'
            };
            return map[key] || 'BGP';
        }
        _.each(data.LineSet, function(item) {
            lineSet[item.LineId] = lineNameMap(item.LineName);
            lineNameSet[item.LineId] = item.LineName;
        });
        state.eipLineNameSet = lineNameSet;
        state.LineSet = lineSet;
    },

    [kecConst.QueryProductGroups](state, res) {
        state.productGroups = res;
    },
    [kecConst.attachKey](state, data) {
        state.KeySet = data.KeySet;
    },
    [kecConst.DescribeUpdateInfos](state, data) {
        state.DescribeUpdateInfos = data.data;
    },
    [kecConst.DescribeOverView](state, data) {
        let overviewlist = [];
        let totalkecnum = 0,
            activenum = 0,
            toexpirenum = 0,
            expirednum = 0,
            othernum = 0,
            memnum = 0,
            imagenum = 0,
            ebsnum = 0,
            localdisknum = 0,
            vcpunum = 0,
            snapshotTotalCount = 0,
            snapshotTotalSize = 0,
            snapshotDailyIncremental = 0,
            allRecentCreated = 0;
        _.forEach(data, (item, index) => {
            let oitem={}
            oitem = _.values(item)[0];
            oitem.region = _.keys(item)[0];
            totalkecnum += oitem.InstanceCount;
            activenum += oitem.Active;
            toexpirenum += oitem.AboutToExpired;
            expirednum += oitem.Expired;
            othernum += oitem.Other;
            // 对取不到某些字段的兼容
            vcpunum += _.get(oitem,'VcpusCount',0);
            memnum += _.get(oitem,'MemoryCount',0);
            imagenum += _.get(oitem,'ImageCount',0);
            ebsnum += _.get(oitem,'EbsVolumeCount',0);
            localdisknum += _.get(oitem,'LocalVolumeCount',0);
            snapshotTotalCount += _.get(oitem, 'SnapshotTotalCount', 0);
            snapshotTotalSize += _.get(oitem, 'SnapshotTotalSize', 0);
            allRecentCreated += _.get(oitem, 'RecentCreated', 0);
            snapshotDailyIncremental += _.get(oitem, 'SnapshotDailyIncremental', 0);
            oitem.SnapshotTotalSizeGB = oitem.SnapshotTotalSize ? (oitem.SnapshotTotalSize / (1024 * 1024 * 1024)).toFixed(2) : 0;
            oitem.index = index;
            oitem.chartData = {
                columns: ['instanceStatus', 'instanceNum'],
                rows: [{
                        instanceStatus: '实例总数',
                        instanceNum: oitem.InstanceCount
                    }
                    // ,{
                    //     instanceStatus: '运行中',
                    //     instanceNum: oitem.Active
                    // },
                    // {
                    //     instanceStatus: '即将过期',
                    //     instanceNum: oitem.AboutToExpired
                    // },
                    // {
                    //     instanceStatus: '已过期',
                    //     instanceNum: oitem.Expired
                    // },
                    // {
                    //     instanceStatus: '近期创建',
                    //     instanceNum: 0
                    // }
                ]
            };
            overviewlist.push(oitem)
        });
        overviewlist = _.orderBy(overviewlist, ['InstanceCount'], ['desc']); //...总实例数倒序排列
        
        state.OverViewList = overviewlist;
        state.Totalkecnum = totalkecnum;
        state.Activenum = activenum;
        state.Toexpirenum = toexpirenum;
        state.Expirednum = expirednum;
        state.Othernum = othernum;
        state.CPUnum = vcpunum;
        state.Memnum = memnum;
        state.Imagenum = imagenum;
        state.Ebsnum = ebsnum;
        state.Localdisknum = localdisknum;
        state.SnapshotTotalCount = snapshotTotalCount;
        state.AllRecentCreated = allRecentCreated;
        state.SnapshotTotalSize = snapshotTotalSize ? (snapshotTotalSize / (1024 * 1024 * 1024)).toFixed(2) : 0;
        state.SnapshotDailyIncremental = snapshotDailyIncremental ? (snapshotDailyIncremental / (1024 * 1024 * 1024)).toFixed(2) : 0;
    },
    [kecConst.DescribeAvailableVolumes](state, data) {
        state.data = data;
    },
    [kecConst.DescribeInstanceVolumes](state, data) {
        state.data = data;
    },
    //--以下为未登录mutations--
    [kecConst.noLoginCalcKvmPrice](state, kecPriceSet) {
        state.kecPriceSet = kecPriceSet;
    },
    [kecConst.noLoginCalcEipPrice](state, eipPriceSet) {
        state.eipPriceSet = eipPriceSet;
    },
    [kecConst.noLoginCreateProduct](state, createProductSet) {
        state.createProductSet = createProductSet;
    },
    //--以上为未登录mutations--
}
